<form
  [formGroup]="form"
  (ngSubmit)="onSubmit(formDirective)"
  #formDirective="ngForm"
>
  <div class="flex lg:flex-row flex-col *:w-full gap-4">
    <article class="form-control">
      <mat-label>Mot de passe actuel</mat-label>
      <mat-form-field color="primary" appearance="outline">
        <input
          #currentPasswordInput
          formControlName="password"
          autocomplete="new-password"
          matInput
          type="password"
          placeholder="**********"
        />
        <mat-error
          *ngIf="form.get('password')?.getError('httpError') as error"
          [innerHtml]="error"
        ></mat-error>

        <button
          mat-icon-button
          type="button"
          matSuffix
          (click)="
            currentPasswordInput.type === 'password'
              ? (currentPasswordInput.type = 'text')
              : (currentPasswordInput.type = 'password')
          "
        >
          <mat-icon>{{
            currentPasswordInput.type === 'password'
              ? 'visibility_off'
              : 'visibility'
          }}</mat-icon>
        </button>
      </mat-form-field>
    </article>
    <article class="form-control">
      <mat-label>Nouveau mot de passe</mat-label>
      <mat-form-field color="primary" appearance="outline" class="filled-field">
        <input
          formControlName="newPassword"
          #newPasswordInput
          matInput
          type="password"
          autocomplete="new-password"
          placeholder="**********"
        />
        <mat-error
          *ngIf="form.get('newPassword')?.getError('httpError') as error"
          [innerHtml]="error"
        ></mat-error>

        <button
          mat-icon-button
          #newPasswordInput
          matSuffix
          type="button"
          (click)="
            newPasswordInput.type === 'password'
              ? (newPasswordInput.type = 'text')
              : (newPasswordInput.type = 'password')
          "
        >
          <mat-icon>{{
            newPasswordInput.type === 'password'
              ? 'visibility_off'
              : 'visibility'
          }}</mat-icon>
        </button>
      </mat-form-field>
    </article>
  </div>
  <div class="flex justify-end">
    <button
      [loading]="isLoading()"
      [disabled]="form.invalid || isLoading()"
      button
      type="submit"
    >
      MODIFIER LE MOT DE PASSE
    </button>
  </div>
</form>

<ng-template #requiredError> Ce champ est requis </ng-template>
